import { jsx as e } from "react/jsx-runtime";
import { useChatbotContext as o } from "../../hooks/useChatbotContext.js";
import { BotMessageMarkdown as t } from "./BotMessageMarkdown.js";
function a() {
  const { chatbot: r } = o();
  return (r == null ? void 0 : r.disclosureText) != null ? /* @__PURE__ */ e(t, { className: "text-[13px] leading-5 text-card-foreground/70 [&_a:hover]:!bg-card [&_a]:!text-card-foreground/70", children: r.disclosureText }) : null;
}
export {
  a as BotDisclosure
};
